class ProductGroupingPicker extends HTMLElement {
  connectedCallback() {
    const inputs = this.querySelectorAll('[data-grouping-picker-option-inputs] input[type="radio"]');
    inputs.forEach(input => {
      input.addEventListener('change', (event) => {
        const targetUrl = event.target.dataset.productUrl;
        if (targetUrl && this.dataset.url !== targetUrl) {
          window.location.href = targetUrl;
        }
      });
    });

    this.initImageListListeners();
  }

  initImageListListeners() {
    const imageLists = this.querySelectorAll('[data-grouping-image-list]');
    
    imageLists.forEach(list => {
      const labels = list.querySelectorAll('.image-swatches__item');
      
      labels.forEach(label => {
        label.addEventListener('click', (event) => {
          if (label.classList.contains('no-available')) {
            event.preventDefault();
            return;
          }

          const input = this.querySelector(`#${label.getAttribute('for')}`);
          if (input) {
            input.checked = true;
            
            const changeEvent = new Event('change', { bubbles: true });
            input.dispatchEvent(changeEvent);
            
            labels.forEach(l => l.classList.remove('selected'));
            label.classList.add('selected');
          }
        });

        label.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            label.click();
          }
        });
      });
    });
  }
}

customElements.define('product-grouping-picker', ProductGroupingPicker);
